export default __webpack_public_path__ + "alberta-reset.bb65d30cc7ed9973012f.svg";